import { Creative, CreativeType } from '../types'
import { InstagramPostEditor } from '../editors/InstagramPostEditor'
import { FacebookPostEditor } from '../editors/FacebookPostEditor'
import { TikTokVideoEditor } from '../editors/TikTokVideoEditor'
import { LinkedInPostEditor } from '../editors/LinkedInPostEditor'
import { XPostEditor } from '../editors/XPostEditor'
import { YouTubeShortsEditor } from '../editors/YouTubeShortsEditor'
import { PinterestPinEditor } from '../editors/PinterestPinEditor'

export function getEditor(creative: Creative) {
  switch (creative.type) {
    case CreativeType.InstagramPost:
      return <InstagramPostEditor creative={creative as Creative<CreativeType.InstagramPost>} />
    case CreativeType.FacebookPost:
      return <FacebookPostEditor creative={creative as Creative<CreativeType.FacebookPost>} />
    case CreativeType.TikTokVideo:
      return <TikTokVideoEditor creative={creative as Creative<CreativeType.TikTokVideo>} />
    case CreativeType.LinkedInPost:
      return <LinkedInPostEditor creative={creative as Creative<CreativeType.LinkedInPost>} />
    case CreativeType.XPost:
      return <XPostEditor creative={creative as Creative<CreativeType.XPost>} />
    case CreativeType.YouTubeShort:
      return <YouTubeShortsEditor creative={creative as Creative<CreativeType.YouTubeShort>} />
    case CreativeType.PinterestPin:
      return <PinterestPinEditor creative={creative as Creative<CreativeType.PinterestPin>} />
    default:
      return null
  }
}

export const TYPES_WITH_EDITOR: Set<CreativeType> = new Set([
  CreativeType.InstagramPost,
  CreativeType.FacebookPost,
  CreativeType.TikTokVideo,
  CreativeType.LinkedInPost,
  CreativeType.XPost,
  CreativeType.YouTubeShort,
  CreativeType.PinterestPin,
])

const TYPE_LABELS: Record<CreativeType, string> = {
  [CreativeType.InstagramPost]: 'Instagram post',
  [CreativeType.FacebookPost]: 'Facebook post',
  [CreativeType.TikTokVideo]: 'TikTok video',
  [CreativeType.LinkedInPost]: 'LinkedIn post',
  [CreativeType.XPost]: 'X post',
  [CreativeType.YouTubeShort]: 'YouTube short',
  [CreativeType.PinterestPin]: 'Pinterest pin',
}

export function humanLabelForType(type: CreativeType): string {
  return TYPE_LABELS[type] ?? 'creative'
}
